import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input, Form } from 'reactstrap';
import { AppContext } from '../../application/provider';
import PagosPlanillaService from '../../axios_services/pagosplanilla.service';
import Loader from '../Loader/Loader';

const ModalAportacionesPlanilla = ({ isOpen, onClose, onRefresh }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [areaFilter, setAreaFilter] = useState('1'); 
    const [perfilFilter, setPerfilFilter] = useState('');
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState('');
    const [tipoAportacion, setTipoAportacion] = useState('1'); // 1 = ONP, 2 = AFP
    const [categoriaAportacion, setCategoriaAportacion] = useState('1'); // 1=PRIMA, 2=PROFUTURO, 3=HABITAT, 4=INTEGRA
    const [subcategoriaAportacion, setSubcategoriaAportacion] = useState('1'); // 1=FLUJO 2013, 2=SALDO
    
    const [usuariosList, setUsuariosList] = useState([]);
    const [hasConfig, setHasConfig] = useState(false);

    const perfiles = state.catalogos?.perfiles || [];
    const filteredPerfiles = perfiles.filter(p => String(p.macro_area_id) === String(areaFilter));

    useEffect(() => {
        if (isOpen) {
            if (filteredPerfiles.length > 0 && (!perfilFilter || !filteredPerfiles.some(p => String(p.perfil_id) === String(perfilFilter)))) {
                setPerfilFilter(String(filteredPerfiles[0].perfil_id));
            }
        }
    }, [isOpen, areaFilter]);

    useEffect(() => {
        if (isOpen && areaFilter && perfilFilter) {
            loadUsuarios();
        }
    }, [isOpen, areaFilter, perfilFilter]);

    useEffect(() => {
        if (usuarioSeleccionado) {
            checkCurrentConfig();
        } else {
            setHasConfig(false);
        }
    }, [usuarioSeleccionado]);

    const loadUsuarios = async () => {
        setIsLoading(true);
        try {
            const resp = await PagosPlanillaService.getColaboradoresConfig(areaFilter, perfilFilter);
            const users = resp.data.data || [];
            setUsuariosList(users);
            if (users.length > 0) {
                setUsuarioSeleccionado(users[0].usuario_id);
            } else {
                setUsuarioSeleccionado('');
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const checkCurrentConfig = async () => {
        setIsLoading(true);
        try {
            const resp = await PagosPlanillaService.getAportacionesConfig(areaFilter, perfilFilter);
            const data = resp.data.data || [];
            const userConfig = data.find(r => String(r.usuario_id) === String(usuarioSeleccionado));
            if (userConfig && userConfig.tipo_aportacion !== null) {
                setTipoAportacion(String(userConfig.tipo_aportacion));
                setCategoriaAportacion(String(userConfig.categoria_aportacion || '1'));
                setSubcategoriaAportacion(String(userConfig.subcategoria_aportacion || '1'));
                setHasConfig(true);
            } else {
                setTipoAportacion('1');
                setCategoriaAportacion('1');
                setSubcategoriaAportacion('1');
                setHasConfig(false);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSave = async () => {
        if (!usuarioSeleccionado) {
            alert('Por favor seleccione un colaborador.');
            return;
        }

        setIsLoading(true);
        try {
            await PagosPlanillaService.updateAportacion({
                usuario_id: usuarioSeleccionado,
                tipo_aportacion: parseInt(tipoAportacion),
                categoria_aportacion: tipoAportacion === '1' ? null : parseInt(categoriaAportacion),
                subcategoria_aportacion: (tipoAportacion === '2' && categoriaAportacion === '4') ? parseInt(subcategoriaAportacion) : null
            });
            alert('Configuración guardada correctamente.');
            if (onRefresh) onRefresh();
            onClose();
        } catch (e) {
            console.error(e);
            alert('Error al guardar configuración.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>GESTIÓN DE APORTACIONES - PLANILLA</h1>
                    <button className="close-btn" onClick={onClose}>X</button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body p-4">
                    {isLoading && <Loader />}
                    
                    <p className="text-muted mb-4 px-4" style={{ fontSize: '12px', lineHeight: '1.2' }}>
                        Seleccione el colaborador y configure su tipo de aportación (ONP/AFP).
                    </p>

                    <Form onSubmit={(e) => { e.preventDefault(); handleSave(); }} className="px-4">
                        <FormGroup className="mb-3">
                            <Label>Área:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={areaFilter}
                                onChange={(e) => setAreaFilter(e.target.value)}
                            >
                                <option value="1">ADMINISTRACIÓN</option>
                                <option value="2">NEGOCIOS</option>
                                <option value="4">GERENCIA</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Perfil:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={perfilFilter}
                                onChange={(e) => setPerfilFilter(e.target.value)}
                            >
                                {filteredPerfiles.map(p => (
                                    <option key={p.perfil_id} value={p.perfil_id}>{p.descripcion.toUpperCase()}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Usuario:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={usuarioSeleccionado}
                                onChange={(e) => setUsuarioSeleccionado(e.target.value)}
                            >
                                {usuariosList.length > 0 ? usuariosList.map(u => (
                                    <option key={u.usuario_id} value={u.usuario_id}>{u.nombre_completo.toUpperCase()}</option>
                                )) : (
                                    <option value="">No hay usuarios</option>
                                )}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Tipo de Aportación:</Label>
                            <Input 
                                type="select"
                                className="form-control"
                                value={tipoAportacion}
                                onChange={(e) => setTipoAportacion(e.target.value)}
                            >
                                <option value="1">ONP</option>
                                <option value="2">AFP</option>
                            </Input>
                        </FormGroup>

                        {tipoAportacion === '2' && (
                            <FormGroup className="mb-4">
                                <Label>Categoría AFP:</Label>
                                <Input 
                                    type="select"
                                    className="form-control"
                                    value={categoriaAportacion}
                                    onChange={(e) => setCategoriaAportacion(e.target.value)}
                                >
                                    <option value="1">PRIMA</option>
                                    <option value="2">PROFUTURO</option>
                                    <option value="3">HABITAT</option>
                                    <option value="4">INTEGRA</option>
                                </Input>
                            </FormGroup>
                        )}

                        {(tipoAportacion === '2' && categoriaAportacion === '4') && (
                            <FormGroup className="mb-4">
                                <Label>Tipo de Comisión (INTEGRA):</Label>
                                <Input 
                                    type="select"
                                    className="form-control"
                                    value={subcategoriaAportacion}
                                    onChange={(e) => setSubcategoriaAportacion(e.target.value)}
                                >
                                    <option value="1">FLUJO 2013 (COMISIÓN 1.55%)</option>
                                    <option value="2">SALDO (SIN COMISIÓN)</option>
                                </Input>
                            </FormGroup>
                        )}

                        <div className="flex justify-end mt-4 pb-3">
                            <Button className="btn-primary px-5 py-2" onClick={handleSave} style={{ borderRadius: '8px' }}>
                                REGISTRAR
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalAportacionesPlanilla;
